import storage from 'localforage';
storage.config({ name: 'reduxpersist' });
export default storage;
